/* eslint-disable no-param-reassign */
import { consumerServer, customerBackend } from './apiConfig'
import store from './store'

interface Headers {
  [key: string]: string
}

type Args = [string, string?, ({ [key: string]: any } | null)?, Headers?, string?]

// eslint-disable-next-line default-param-last
const request = async (path: string, method = 'GET', body?: { [key: string]: any } | null, headers: Headers = {}, backendService?: string) => {
  const { session } = store.getState()
  let backendUrl = consumerServer
  let authToken = ''
  let locale = ''
  try {
    authToken = session.authToken || ''
  } catch (error) {
    authToken = ''
  }

  try {
    locale = session.locale || ''
  } catch (error) {
    locale = ''
  }
  const { phoneModel, appVersion } = session.phoneCharacteristics

  if (phoneModel) headers['x-phone-model'] = phoneModel
  if (appVersion) headers['x-app-version'] = appVersion
  if (locale) headers['x-locale'] = locale

  if (backendService === 'app-customer-lambda') {
    backendUrl = customerBackend
  }

  if (backendUrl.includes('ngrok')) {
    console.log('setting ngrok header!')
    headers['ngrok-skip-browser-warning'] = 'true'
  }
  const response = await fetch(`${backendUrl}${path}`, {
    method,
    body: body && JSON.stringify(body),
    headers: {
      ...headers,
      Authorization: authToken && `Bearer ${authToken}`,
      'Content-Type': 'application/json',
    },
  })
  const data = await response.json()
  if (response.status >= 400) {
    const error = new Error(data.errorMessage || data.message) as RequestError
    error.status = response.status
    error.info = data.info
    throw error
  }
  // Uncomment the below line if you want to log the request and response
  // console.log(JSON.stringify(data));

  return data
}
const debounce = (inner: (...args: any[]) => Promise<any>, ms = 100) => {
  let timer: any = null
  let resolves: ((value: any) => void)[] = []

  return (...args: Args) => {
    // Run the function after a certain amount of time
    clearTimeout(timer)
    timer = setTimeout(() => {
      // Get the result of the inner function, then apply it to the resolve function of
      // each promise that has been created since the last time the inner function was run
      const result = inner(...args)
      resolves.forEach((r) => r(result))
      resolves = []
    }, ms)

    // eslint-disable-next-line no-promise-executor-return
    return new Promise((r) => resolves.push(r))
  }
}

const debounceWithFirstArg = (inner: (...args: Args) => Promise<any>) => {
  const debounced: { [key: string]: (...args: Args) => Promise<any> } = {}

  return (...args: Args) => {
    const [firstArg] = args
    if (!debounced[firstArg]) debounced[firstArg] = debounce(inner)
    return debounced[firstArg](...args)
  }
}

export default debounceWithFirstArg(request)
